import React, { useState, useEffect } from "react"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
} from "reactstrap"
import { connect } from "react-redux"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import EditableColumn from "./EditableColumn"
import { withRouter } from "react-router-dom"
import Toaster from "../../components/Common/Toaster"
import * as backend from "../../helpers/backend_helper"

// Stable client-side ids so drag ids / react keys follow an item across reorders.
const uid = () => "u" + Math.random().toString(36).slice(2, 10) + (Date.now() % 100000).toString(36)
const withUids = (groups: any[]) =>
    (groups || []).map((g: any) => ({
        ...g,
        _uid: g._uid || uid(),
        lists: (g.lists || []).map((l: any) => ({ ...l, _uid: l._uid || uid() })),
    }))

const WorkReportScope = (props: any) => {
    const {
        match: {
            params: { orgId, facId },
        },
    } = props

    const [reports, setReports] = useState<any[]>([])

    // add group
    function addGroup() {
        setReports([...reports, { name: null, lists: [], _uid: uid() }])
    }

    useEffect(() => {
        if (props.factory.workReportScope)
            setReports(withUids(props.factory.workReportScope))
    }, [])

    // on submit
    async function submit() {
        try {
            await backend.updateFactory(orgId, facId, {
                workReportScope: reports,
            })
            Toaster.success("Work Scope Updated Success")
        } catch (e) {
            console.log("work scope error", e)
            Toaster.error("Work Scope Updated Failed")
        }
        // console.log(reports)
    }
    // remove group
    function removeGroup(idx: any) {
        const cloneList = [...reports]
        cloneList.splice(idx, 1)
        setReports([...cloneList])
    }

    function addSubList(id: any) {
        const cloneList = [...reports]
        cloneList[id].lists = [
            ...cloneList[id].lists,
            { name: null, _uid: uid() },
        ]
        setReports([...cloneList])
    }

    function updateGroupValue(e: any, key: any, idx: any) {
        const cloneList = [...reports]
        cloneList[idx][key] = e
        setReports([...cloneList])
    }

    function updateListValue(e: any, key: any, idx: any, liIndex: any) {
        const cloneList = [...reports]
        const list = cloneList[idx].lists[liIndex]
        if (list) {
            list[key] = e
        }
        setReports([...cloneList])
    }

    function onDelete(idd: any, subIndex: any) {
        const cloneList = [...reports]
        const list = cloneList[idd].lists
        list.splice(subIndex, 1)
        setReports([...cloneList])
    }

    // Drag: reorder groups, and reorder / move points within or across headers.
    function onDragEnd(result: any) {
        const { source, destination, type } = result
        if (!destination) return
        if (type === "group") {
            if (source.index === destination.index) return
            const clone = [...reports]
            const [moved] = clone.splice(source.index, 1)
            clone.splice(destination.index, 0, moved)
            setReports(clone)
            return
        }
        const fromG = reports.findIndex(g => g._uid === source.droppableId)
        const toG = reports.findIndex(g => g._uid === destination.droppableId)
        if (fromG < 0 || toG < 0) return
        if (fromG === toG && source.index === destination.index) return
        const clone = [...reports]
        const fromLists = [...clone[fromG].lists]
        const [moved] = fromLists.splice(source.index, 1)
        if (fromG === toG) {
            fromLists.splice(destination.index, 0, moved)
            clone[fromG] = { ...clone[fromG], lists: fromLists }
        } else {
            const toLists = [...clone[toG].lists]
            toLists.splice(destination.index, 0, moved)
            clone[fromG] = { ...clone[fromG], lists: fromLists }
            clone[toG] = { ...clone[toG], lists: toLists }
        }
        setReports(clone)
    }

    const SubListRender = (sublist: any, subIndex: any, idd: any) => (
        <Row className="align-items-center">
            <Col lg={9}>
                <EditableColumn
                    value={sublist.name}
                    update={(e: any) => updateListValue(e, "name", idd, subIndex)}
                />
            </Col>
            <Col lg={1}>
                <button
                    onClick={e => onDelete(idd, subIndex)}
                    type="button"
                    className="btn btn-danger waves-effect waves-light"
                >
                    <i className="mdi mdi-trash-can d-block font-size-16"></i>{" "}
                </button>
            </Col>
        </Row>
    )
    return (
        <React.Fragment>
            <Container fluid>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <button
                        onClick={addGroup}
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                    >
                        New Group
                    </button>
                </div>
                <br />
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="groups" type="group">
                                        {gprov => (
                                            <ul
                                                className="list-unstyled"
                                                style={{ height: "60vh", overflow: "auto" }}
                                                ref={gprov.innerRef}
                                                {...gprov.droppableProps}
                                            >
                                                {reports &&
                                                    reports.map((report, idd) => (
                                                        <Draggable key={report._uid} draggableId={`group-${report._uid}`} index={idd}>
                                                            {gp => (
                                                                <li ref={gp.innerRef} {...gp.draggableProps}>
                                                                    <div
                                                                        className="factory-monitoring-group-list"
                                                                        style={{ textAlign: "start" }}
                                                                    >
                                                                        <Row className="align-items-center">
                                                                            <Col md={1}>
                                                                                <i
                                                                                    className="mdi mdi-drag-vertical"
                                                                                    title="Drag to reorder group"
                                                                                    style={{ cursor: "grab", fontSize: "22px", color: "#1D3A5F" }}
                                                                                    {...gp.dragHandleProps}
                                                                                />
                                                                            </Col>
                                                                            <Col md={10}>
                                                                                <EditableColumn
                                                                                    value={report.name}
                                                                                    update={(e: any) => updateGroupValue(e, "name", idd)}
                                                                                />
                                                                            </Col>
                                                                            <Col md={1}>
                                                                                <button
                                                                                    onClick={e => removeGroup(idd)}
                                                                                    type="button"
                                                                                    className="btn btn-danger waves-effect waves-light"
                                                                                >
                                                                                    <i className="mdi mdi-trash-can d-block font-size-16"></i>{" "}
                                                                                </button>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <Droppable droppableId={report._uid} type="point">
                                                                        {(pprov, psnap) => (
                                                                            <ul
                                                                                className="list-unstyled"
                                                                                ref={pprov.innerRef}
                                                                                {...pprov.droppableProps}
                                                                                style={{ minHeight: 12, background: psnap.isDraggingOver ? "#eef7f5" : "transparent", borderRadius: 8 }}
                                                                            >
                                                                                {report.lists.map((sublist: any, subIndex: any) => (
                                                                                    <Draggable key={sublist._uid} draggableId={`point-${sublist._uid}`} index={subIndex}>
                                                                                        {dp => (
                                                                                            <li ref={dp.innerRef} {...dp.draggableProps} style={{ padding: "10px", ...dp.draggableProps.style }}>
                                                                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                                                                    <i
                                                                                                        className="mdi mdi-drag-vertical"
                                                                                                        title="Drag to reorder / move to another header"
                                                                                                        style={{ cursor: "grab", fontSize: "20px", color: "#8a97a8", marginRight: "8px" }}
                                                                                                        {...dp.dragHandleProps}
                                                                                                    />
                                                                                                    <div style={{ flex: 1 }}>
                                                                                                        {SubListRender(sublist, subIndex, idd)}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </li>
                                                                                        )}
                                                                                    </Draggable>
                                                                                ))}
                                                                                {pprov.placeholder}
                                                                            </ul>
                                                                        )}
                                                                    </Droppable>

                                                                    <Col lg={10} md={10} style={{ textAlign: "center", padding: "24px 0px" }}>
                                                                        <button
                                                                            onClick={e => addSubList(idd)}
                                                                            type="button"
                                                                            className="btn btn-primary waves-effect waves-light"
                                                                        >
                                                                            ADD
                                                                        </button>
                                                                    </Col>
                                                                </li>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                {gprov.placeholder}
                                            </ul>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                                {reports && reports.length > 0 && (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button onClick={submit} color="success">
                                            Submit
                                        </Button>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
}

export default withRouter(connect(null, {})(WorkReportScope))
